import { ModelBase } from "./ModelBase";
import { AssetBase } from "./AssetBase";
import { SubscriptionBase } from "./SubscriptionBase";

// account type enum
export enum AccountType {
  Individual = "Individual",
  Business = "Business",
  SMSF = "SMSF",
}

// account sub type enum
export enum AccountSubType {
  Investor = "Investor",
  Trader = "Trader",
}

export enum ParcelMethodType {
  FIFO = "FIFO",
  LIFO = "LIFO",
  HIFO = "HIFO",
  LTFO = "LTFO",
}

export interface ParcelMethod {
  startYear: string;
  endYear: string;
  method: ParcelMethodType;
}

export interface Address {
  street: string;
  suite: string;
  suburb: string;
  state: string;
  postcode: string;
}

export interface PhoneNumber {
  countryCode: string;
  number: string;
}

export interface TaxSettingsBase<TId> {
  homeCountry: string;
  baseCurrency: AssetBase<TId>;
  taxYear: string;
  gstRegistered: boolean;
  parcelMethods: ParcelMethod[];
  timeZone: string;
  defaultParcelMethod?: ParcelMethodType;
}

// necessary fields
export interface UserBase<TId> extends ModelBase<TId> {
  email: string;
  accountType: AccountType;
  accountSubType: AccountSubType;
  fullName: string;
  entityName: string;
  abn: string;
  address: Address;
  contactNumber: PhoneNumber;

  taxSettings: TaxSettingsBase<TId>;
  invitedAccountants: string[];

  stripeCustomerId?: string;
  subscriptions: SubscriptionBase<TId>[];

  stripeConnectedAccountId?: string;

  supportAccess?: boolean;

  createdAt?: Date;
  updatedAt?: Date;
}
